module.exports = __webpack_public_path__ + "img/intuit_logo.0ec0adc9.svg";